import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/switchMap";

import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class AuthService {
	loggedIn: boolean;
	baseUri: string = "https://jwt-demo.openshift.techgap.it/";
	local_storage_title: string = "anoki:authtoken";

	constructor(private http: HttpClient) {}

	login(body: any): Promise<any> {
		return this.http
			.post<any>(`${this.baseUri}login`, JSON.stringify(body), {
				headers: new HttpHeaders({
					"Content-Type": "application/json"
				})
			})
			.switchMap(data => {
				if (data !== null) {
					this.saveDataToLocalStorage(
						data.headers.get("Authorization")
					);
				}
				return data;
			})
			.toPromise();
	}
	checkState(): Observable<any> {
		if (window.localStorage.getItem(this.local_storage_title) !== null) {
			return Observable.of(true);
		} else {
			return Observable.of(false);
		}
	}

	logout() {}

	getProfileData(): Promise<any> {
		return this.http
			.get<any>(`${this.baseUri}profile`, {
				headers: new HttpHeaders({
					jwt: `Bearer ${this.getTokenFromLocalStorage()}`
				})
			})
			.toPromise();
	}

	saveDataToLocalStorage(token: any) {
		window.localStorage.setItem(
			this.local_storage_title,
			JSON.stringify({ created: Date.now(), token: token })
		);
	}
	getTokenFromLocalStorage(): string {
		return JSON.parse(window.localStorage.getItem(this.local_storage_title))
			.token;
	}
}



// WEBPACK FOOTER //
// F:/Projects/anoki/src/app/core/auth.service.ts